import { render, staticRenderFns } from "./load-previous.vue?vue&type=template&id=22ef3021&"
import script from "./load-previous.vue?vue&type=script&lang=js&"
export * from "./load-previous.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports